import * as React from 'react';

import cn from 'classnames';

import { HtmlEntities } from '@utils';

import { Icon } from '@components';

import { IconClose } from '@icons';

import { IAlertProps } from './types';

import * as s from './Alert.scss';

export const Alert = ({
	html,
	className,
	onClose,
}: IAlertProps) =>
	<div className={cn(s.root, className)}>
		<Icon
			className={s.close}
			glyph={IconClose}
			onClick={onClose}
		/>

		<div
			className={s.html}
			dangerouslySetInnerHTML={{ __html: HtmlEntities.decode(html) }}
		/>
	</div>;
